"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const events_1 = require("events");
const ethers = tslib_1.__importStar(require("ethers"));
const enc_utils_1 = require("enc-utils");
const client_1 = tslib_1.__importDefault(require("@walletconnect/client"));
const starkware_controller_1 = tslib_1.__importDefault(require("@authereum/starkware-controller"));
const starkware_crypto_1 = require("@authereum/starkware-crypto");
const BasicProvider_1 = tslib_1.__importDefault(require("./BasicProvider"));
class Connection extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        this.connected = true;
        this.send = (payload) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { method, params } = payload;
            return this._provider.resolveResult(method, params);
        });
    }
    open() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.connected = true;
        });
    }
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.connected = false;
        });
    }
    setProvider(provider) {
        this._provider = provider;
    }
}
function matches(a, b) {
    if (typeof a !== typeof b)
        return false;
    let match = true;
    Object.keys(a).forEach(key => {
        if (a[key] !== b[key])
            match = false;
    });
    return match;
}
class WalletConnectClientWrapper extends events_1.EventEmitter {
    constructor() {
        super();
        this._wc = null;
        const session = this.getSession();
        if (session) {
            const walletConnector = new client_1.default({ session });
            this._wc = walletConnector;
            this._setupEvenEmitter();
        }
    }
    _setupEvenEmitter() {
        var _a;
        const events = [
            'connect',
            'disconnect',
            'session_request',
            'session_update',
            'call_request',
            'wc_sessionRequest',
            'wc_sessionUpdate',
            'error',
            'transport_open',
            'transport_close',
        ];
        for (const name of events) {
            (_a = this._wc) === null || _a === void 0 ? void 0 : _a.on(name, (...args) => this.emit(name, ...args));
        }
    }
    get connected() {
        var _a;
        return !!((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connected);
    }
    connect(connectUri) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._wc = new client_1.default({
                uri: connectUri,
            });
            if (!((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connected)) {
                yield this.createSession();
            }
            this._setupEvenEmitter();
        });
    }
    createSession() {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.createSession();
    }
    killSession() {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.killSession();
    }
    approveSession(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveSession(params);
    }
    rejectSession(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveSession(params);
    }
    approveRequest(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.approveRequest(params);
    }
    rejectRequest(params) {
        var _a;
        return (_a = this._wc) === null || _a === void 0 ? void 0 : _a.rejectRequest(params);
    }
    getSession() {
        try {
            const session = localStorage.getItem('walletconnect');
            if (!session) {
                return null;
            }
            return JSON.parse(session);
        }
        catch (err) {
            return null;
        }
    }
}
class StarkwareWalletConnectProvider {
    constructor(wc, opts = {}) {
        this._wc = null;
        this._debug = false;
        this._debugLog = (...args) => {
            if (!this._debug) {
                return;
            }
            console.debug('[stark-provider-wc]', ...args);
        };
        this._wc = wc;
        if (opts && opts.debug) {
            this._debug = true;
        }
    }
    sendRequest(method, params = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('sendRequest', method, params);
            const customRequest = {
                id: Date.now(),
                jsonrpc: '2.0',
                method,
                params,
            };
            if ((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connector) {
                return (_c = (_b = this._wc) === null || _b === void 0 ? void 0 : _b.connector) === null || _c === void 0 ? void 0 : _c.sendCustomRequest(customRequest);
            }
            else if ((_d = this._wc) === null || _d === void 0 ? void 0 : _d._wc) {
                return (_f = (_e = this._wc) === null || _e === void 0 ? void 0 : _e._wc) === null || _f === void 0 ? void 0 : _f.sendCustomRequest(customRequest);
            }
            else if ((_g = this._wc) === null || _g === void 0 ? void 0 : _g.sendCustomRequest) {
                return (_h = this._wc) === null || _h === void 0 ? void 0 : _h.sendCustomRequest(customRequest);
            }
        });
    }
    account(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('account', layer, application, index);
            const { starkKey } = yield this.sendRequest('stark_account', {
                layer,
                application,
                index,
            });
            return starkKey;
        });
    }
    requestAccounts() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('requestAccounts');
            const accounts = yield this.sendRequest('eth_requestAccounts');
            return accounts;
        });
    }
    personalSign(msg) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('personalSign', msg);
            let address = null;
            if ((_a = this._wc) === null || _a === void 0 ? void 0 : _a.connector) {
                address = (_c = (_b = this._wc) === null || _b === void 0 ? void 0 : _b.connector) === null || _c === void 0 ? void 0 : _c.accounts[0];
            }
            else if ((_d = this._wc) === null || _d === void 0 ? void 0 : _d._wc) {
                address = (_f = (_e = this._wc) === null || _e === void 0 ? void 0 : _e._wc) === null || _f === void 0 ? void 0 : _f.accounts[0];
            }
            else if ((_g = this._wc) === null || _g === void 0 ? void 0 : _g.accounts) {
                address = (_h = this._wc) === null || _h === void 0 ? void 0 : _h.accounts[0];
            }
            const signature = yield this.sendRequest('personal_sign', [msg, address]);
            return signature;
        });
    }
    registerUser(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('registerUser', params);
            const { txhash } = yield this.sendRequest('stark_register', params);
            return txhash;
        });
    }
    deposit(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('deposit', params);
            const { txhash } = yield this.sendRequest('stark_deposit', params);
            return txhash;
        });
    }
    withdraw(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('withdraw', params);
            const { txhash } = yield this.sendRequest('stark_withdraw', params);
            return txhash;
        });
    }
    transfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('transfer', params);
            const { starkSignature } = yield this.sendRequest('stark_transfer', params);
            return starkSignature;
        });
    }
    createOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('createOrder', params);
            const { starkSignature } = yield this.sendRequest('stark_createOrder', params);
            return starkSignature;
        });
    }
    perpetualTransfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualTransfer', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualTransfer', params);
            return starkSignature;
        });
    }
    perpetualLimitOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualLimitOrder', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualLimitOrder', params);
            return starkSignature;
        });
    }
    perpetualWithdrawal(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('perpetualWithdrawal', params);
            const { starkSignature } = yield this.sendRequest('stark_perpetualWithdrawal', params);
            return starkSignature;
        });
    }
}
exports.StarkwareWalletConnectProvider = StarkwareWalletConnectProvider;
class StarkwareProvider extends BasicProvider_1.default {
    constructor(starkWallet, signerWallet, contractAddress, connection = new Connection()) {
        super(connection);
        this._debug = false;
        this._debugLog = (...args) => {
            if (!this._debug) {
                return;
            }
            console.debug('[stark-provider]', ...args);
        };
        this.resolveResult = (method, params, txOpts = {}) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('resolveResult', method, params);
            if (typeof method !== 'string') {
                ;
                ({ method, params } = method);
            }
            switch (method) {
                case 'stark_account': {
                    const { layer, application, index } = params;
                    const starkKey = yield this.account(layer, application, index);
                    return {
                        starkKey,
                    };
                }
                case 'stark_register': {
                    const txhash = yield this.registerUser(params, txOpts);
                    return { txhash };
                }
                case 'stark_deposit': {
                    const txhash = yield this.deposit(params, txOpts);
                    return { txhash };
                }
                case 'stark_depositCancel': {
                    const txhash = yield this.cancelDeposit(params, txOpts);
                    return { txhash };
                }
                case 'stark_depositReclaim': {
                    const txhash = yield this.reclaimDeposit(params, txOpts);
                    return { txhash };
                }
                case 'stark_depositNft': {
                    const txhash = yield this.deposit(params, txOpts);
                    return { txhash };
                }
                case 'stark_depositNftReclaim': {
                    const txhash = yield this.reclaimDeposit(params, txOpts);
                    return { txhash };
                }
                case 'stark_withdraw': {
                    const txhash = yield this.withdraw(params, txOpts);
                    return { txhash };
                }
                case 'stark_withdrawTo': {
                    const txhash = yield this.withdraw(params, txOpts);
                    return { txhash };
                }
                case 'stark_fullWithdrawal': {
                    const txhash = yield this.fullWithdrawalRequest(params, txOpts);
                    return { txhash };
                }
                case 'stark_withdrawAndMint': {
                    const txhash = yield this.withdrawAndMint(params, txOpts);
                    return { txhash };
                }
                case 'stark_withdrawNft': {
                    const txhash = yield this.withdraw(params, txOpts);
                    return { txhash };
                }
                case 'stark_withdrawNftTo': {
                    const txhash = yield this.withdraw(params, txOpts);
                    return { txhash };
                }
                case 'stark_freeze': {
                    const txhash = yield this.freezeRequest(params, txOpts);
                    return { txhash };
                }
                case 'stark_escape': {
                    const txhash = yield this.escape(params, txOpts);
                    return { txhash };
                }
                case 'stark_transfer': {
                    this._debugLog('stark_transfer', params);
                    const starkSignature = yield this.transfer(params);
                    this._debugLog('stark_transfer', 'signature', starkSignature);
                    return { starkSignature };
                }
                case 'stark_createOrder': {
                    const starkSignature = yield this.createOrder(params);
                    return { starkSignature };
                }
                case 'stark_perpetualTransfer': {
                    const starkSignature = yield this.perpetualTransfer(params);
                    return { starkSignature };
                }
                case 'stark_perpetualLimitOrder': {
                    const starkSignature = yield this.perpetualLimitOrder(params);
                    return { starkSignature };
                }
                case 'stark_perpetualWithdrawal': {
                    const starkSignature = yield this.perpetualWithdrawal(params);
                    return { starkSignature };
                }
                case 'personal_sign': {
                    const message = params[0];
                    return this.personalSign(message);
                }
                case 'eth_sign': {
                    const message = params[1];
                    return this.signMessage(message);
                }
                case 'eth_signTransaction': {
                    const tx = params[1];
                    return this.signTransaction(tx);
                }
                case 'eth_sendTransaction': {
                    const tx = params[1] || params[0];
                    this._debugLog('eth_sendTransaction', tx);
                    const txRes = yield this.sendTransaction(tx);
                    return txRes.hash;
                }
                case 'eth_accounts': {
                    const address = yield this.getAddress();
                    if (address) {
                        return [address];
                    }
                    return [];
                }
                case 'eth_requestAccounts': {
                    return this.requestAccounts();
                }
                case 'net_version': {
                    return this._signerWallet.getChainId();
                }
                case 'eth_chainId': {
                    return this._signerWallet.getChainId();
                }
                case 'eth_coinbase': {
                    const address = yield this.getAddress();
                    return address;
                }
                case 'eth_blockNumber': {
                    return this._signerWallet.provider.getBlockNumber();
                }
                case 'eth_getBalance': {
                    return this._signerWallet.getBalance();
                }
                case 'eth_getTransactionCount': {
                    return this._signerWallet.getTransactionCount();
                }
                case 'eth_getTransactionCount': {
                    throw new Error('not implemented');
                }
                case 'eth_getCode': {
                    throw new Error('not implemented');
                }
                case 'eth_getCode': {
                    throw new Error('not implemented');
                }
                case 'eth_sendRawTransaction': {
                    throw new Error('not implemented');
                }
                case 'eth_getTransactionByHash': {
                    throw new Error('not implemented');
                }
                case 'eth_getTransactionReceipt': {
                    throw new Error('not implemented');
                }
                case 'eth_getBlockByNumber': {
                    throw new Error('not implemented');
                }
                case 'eth_getBlockByHash': {
                    throw new Error('not implemented');
                }
                case 'eth_estimateGas': {
                    return this._signerWallet.estimateGas(params);
                }
                case 'eth_gasPrice': {
                    return this._signerWallet.getGasPrice();
                }
                case 'eth_call': {
                    return this._signerWallet.call(params);
                }
                default: {
                    console.debug('METHOD:', method, 'PARAMS:', params);
                    throw new Error(`Unknown Starkware RPC Method: ${method}`);
                }
            }
        });
        this.getAddress = () => {
            this._debugLog('getAddress');
            return this._signerWallet.getAddress();
        };
        connection.setProvider(this);
        this._starkWallet = starkWallet;
        this._signerWallet = signerWallet;
        this.contractAddress = contractAddress;
        this._controller = new starkware_controller_1.default();
        this.wc = new WalletConnectClientWrapper();
    }
    static fromWalletConnect(wc) {
        return new StarkwareWalletConnectProvider(wc);
    }
    setSigner(signerWallet) {
        this._debugLog('setSigner', signerWallet);
        this._signerWallet = signerWallet;
    }
    setContractAddress(contractAddress) {
        this._debugLog('setContractAddress', contractAddress);
        this.contractAddress = contractAddress;
    }
    setDebug(debug) {
        this._debug = debug;
        this._starkWallet.setDebug(debug);
    }
    resolve(payload, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('resolve', payload);
            let { id, method, params } = payload;
            try {
                const result = yield this.resolveResult(method, params, txOpts);
                return { id, result };
            }
            catch (err) {
                return {
                    id,
                    error: {
                        message: err.message,
                    },
                };
            }
        });
    }
    enable(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('enable', layer, application, index);
            try {
                yield this.open();
                const starkKey = yield this.updateAccount(layer, application, index);
                this._debugLog('enable starkkey', starkKey);
                this.emit('enable');
                return this.requestAccounts();
            }
            catch (err) {
                yield this.close();
                throw err;
            }
        });
    }
    updateAccount(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('updateAccount', layer, application, index);
            if (layer) {
                const accountParams = { layer, application, index };
                if (this.starkKey && matches(this._accountParams, accountParams)) {
                    return this.starkKey;
                }
            }
            return this.account(layer, application, index);
        });
    }
    getActiveAccount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('getActiveAccount');
            if (!this._accountParams) {
                throw new Error('No StarkKey available - please call provider.enable()');
            }
            if (this.starkKey) {
                this._debugLog('getActiveAccount', 'this.starkKey');
                return this.starkKey;
            }
            const { layer, application, index } = this._accountParams;
            return this.account(layer, application, index);
        });
    }
    account(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (application) {
                this._accountParams = { layer, application, index };
            }
            else if (this._accountParams) {
                layer = this._accountParams.layer;
                application = this._accountParams.application;
                index = this._accountParams.index;
            }
            this._debugLog('account', layer, application, index);
            const starkKey = yield this._starkWallet.account(layer, application, index);
            this.starkKey = starkKey;
            return starkKey;
        });
    }
    requestAccounts() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('requestAccounts');
            const address = yield this.getAddress();
            if (address) {
                return [address];
            }
            return [];
        });
    }
    personalSign(message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('requestAccounts');
            return this.signMessage(message);
        });
    }
    registerUser(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { ethKey, operatorSignature } = input;
            const starkKey = yield this.getActiveAccount();
            let registeredEthKey = false;
            try {
                registeredEthKey = !!(yield this.getEthKey(starkKey, txOpts));
            }
            catch (err) {
            }
            if (registeredEthKey) {
                throw new Error('StarkKey is already registered');
            }
            const data = yield this._controller.registerUser({
                ethKey,
                starkKey,
                operatorSignature,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    deposit(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { vaultId, amount, asset } = input;
            const starkKey = yield this.getActiveAccount();
            const assetType = starkware_crypto_1.getAssetType(asset);
            if (asset.type === 'ERC721') {
                const tokenId = asset.data.tokenId;
                const data = yield this._controller.depositNft({
                    starkKey,
                    assetType,
                    vaultId,
                    tokenId,
                });
                const txhash = yield this._sendContractTransaction(data, txOpts);
                return txhash;
            }
            let quantizedAmount = null;
            let ethValue = '';
            if (asset.type === 'ETH') {
                ethValue = starkware_crypto_1.quantizeAmount(amount, asset.data.quantum);
            }
            if (asset.type == 'ERC20') {
                quantizedAmount = starkware_crypto_1.quantizeAmount(amount, asset.data.quantum);
            }
            const data = yield this._controller.deposit({
                starkKey,
                assetType,
                vaultId,
                quantizedAmount,
            });
            txOpts.value = txOpts.value || ethValue;
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    depositEth(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { amount, quantum, vaultId } = input;
            return this.deposit({
                vaultId,
                amount,
                asset: {
                    type: 'ETH',
                    data: {
                        quantum,
                    },
                },
            }, txOpts);
        });
    }
    depositErc20(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { amount, quantum, tokenAddress, vaultId } = input;
            return this.deposit({
                vaultId,
                amount,
                asset: {
                    type: 'ERC20',
                    data: {
                        tokenAddress,
                        quantum,
                    },
                },
            }, txOpts);
        });
    }
    depositErc721(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { tokenId, tokenAddress, vaultId } = input;
            return this.deposit({
                vaultId,
                asset: {
                    type: 'ERC721',
                    data: {
                        tokenAddress,
                        tokenId,
                    },
                },
            }, txOpts);
        });
    }
    cancelDeposit(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { vaultId, asset } = input;
            const starkKey = yield this.getActiveAccount();
            const assetId = starkware_crypto_1.getAssetId(asset);
            const data = yield this._controller.depositCancel({
                starkKey,
                assetId,
                vaultId,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    reclaimDeposit(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { vaultId, asset } = input;
            const starkKey = yield this.getActiveAccount();
            const assetType = starkware_crypto_1.getAssetType(asset);
            if (asset.type === 'ERC721') {
                const tokenId = asset.data.tokenId;
                const data = yield this._controller.depositNftReclaim({
                    starkKey,
                    assetType,
                    vaultId,
                    tokenId,
                });
                const txhash = yield this._sendContractTransaction(data, txOpts);
                return txhash;
            }
            const data = yield this._controller.depositReclaim({
                starkKey,
                assetType,
                vaultId,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    withdraw(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { asset, recipient } = input;
            const starkKey = yield this.getActiveAccount();
            const assetType = starkware_crypto_1.getAssetType(asset);
            if (asset.type === 'ERC721') {
                const tokenId = asset.data.tokenId;
                if (recipient) {
                    const data = yield this._controller.withdrawNftTo({
                        starkKey,
                        assetType,
                        tokenId,
                        recipient,
                    });
                    const txhash = yield this._sendContractTransaction(data, txOpts);
                    return txhash;
                }
                else {
                    const data = yield this._controller.withdrawNft({
                        starkKey,
                        assetType,
                        tokenId,
                    });
                    const txhash = yield this._sendContractTransaction(data, txOpts);
                    return txhash;
                }
            }
            if (recipient) {
                const data = yield this._controller.withdrawTo({
                    starkKey,
                    assetType,
                    recipient,
                });
                const txhash = yield this._sendContractTransaction(data, txOpts);
                return txhash;
            }
            else {
                const data = yield this._controller.withdraw({
                    starkKey,
                    assetType,
                });
                const txhash = yield this._sendContractTransaction(data, txOpts);
                return txhash;
            }
        });
    }
    withdrawEth(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { quantum, recipient } = input;
            return this.withdraw({
                asset: {
                    type: 'ETH',
                    data: {
                        quantum,
                    },
                },
                recipient,
            }, txOpts);
        });
    }
    withdrawErc20(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { tokenAddress, quantum, recipient } = input;
            return this.withdraw({
                asset: {
                    type: 'ERC20',
                    data: {
                        tokenAddress,
                        quantum,
                    },
                },
                recipient,
            }, txOpts);
        });
    }
    withdrawErc721(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { tokenAddress, tokenId, recipient } = input;
            return this.withdraw({
                asset: {
                    type: 'ERC721',
                    data: {
                        tokenAddress,
                        tokenId,
                    },
                },
                recipient,
            }, txOpts);
        });
    }
    withdrawAndMint(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { asset, mintingBlob } = input;
            const starkKey = yield this.getActiveAccount();
            const assetType = starkware_crypto_1.getAssetType(asset);
            const data = yield this._controller.withdrawAndMint({
                starkKey,
                assetType,
                mintingBlob,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    fullWithdrawalRequest(vaultId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented');
        });
    }
    freezeRequest(vaultId, quantizedAmount, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const starkKey = yield this.getActiveAccount();
            const data = yield this._controller.freezeRequest({
                starkKey,
                vaultId,
                quantizedAmount,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    freezeRequestTrade(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const starkKey = yield this.getActiveAccount();
            const data = yield this._controller.freezeRequestTrade(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    escape(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { amount, asset, vaultId } = input;
            const starkKey = yield this.getActiveAccount();
            const assetId = starkware_crypto_1.getAssetId(asset);
            const quantizedAmount = starkware_crypto_1.quantizeAmount(amount, asset.data.quantum);
            const data = yield this._controller.escape({
                starkKey,
                vaultId,
                assetId,
                quantizedAmount,
            });
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    transfer(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { from, to, asset, amount, nonce, expirationTimestamp, condition, } = input;
            const assetId = starkware_crypto_1.getAssetId(asset);
            const quantizedAmount = starkware_crypto_1.quantizeAmount(amount, asset.data.quantum);
            const senderVaultId = from.vaultId;
            const targetVaultId = to.vaultId;
            const targetKey = input.to.starkKey;
            const msgHash = yield this._controller.transfer({
                quantizedAmount,
                nonce,
                senderVaultId,
                assetId,
                targetVaultId,
                targetKey,
                expirationTimestamp,
                condition,
            });
            this._debugLog('transfer', 'msgHash', msgHash);
            const starkSignature = yield this._starkWallet.sign(msgHash);
            return starkSignature;
        });
    }
    transferEth(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const starkKey = yield this.getActiveAccount();
            const { vaultId, to, quantum, amount, nonce, expirationTimestamp, condition, } = input;
            return this.transfer({
                from: {
                    starkKey,
                    vaultId,
                },
                to,
                asset: {
                    type: 'ETH',
                    data: {
                        quantum,
                    },
                },
                amount,
                nonce,
                expirationTimestamp,
                condition,
            });
        });
    }
    transferErc20(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const starkKey = yield this.getActiveAccount();
            const { vaultId, to, tokenAddress, quantum, amount, nonce, expirationTimestamp, condition, } = input;
            return this.transfer({
                from: {
                    starkKey,
                    vaultId,
                },
                to,
                asset: {
                    type: 'ERC20',
                    data: {
                        tokenAddress,
                        quantum,
                    },
                },
                amount,
                nonce,
                expirationTimestamp,
                condition,
            });
        });
    }
    transferErc721(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const starkKey = yield this.getActiveAccount();
            const { vaultId, to, tokenAddress, tokenId, nonce, expirationTimestamp, condition, } = input;
            return this.transfer({
                from: {
                    starkKey,
                    vaultId,
                },
                to,
                asset: {
                    type: 'ERC20',
                    data: {
                        tokenAddress,
                        tokenId,
                    },
                },
                nonce,
                expirationTimestamp,
                condition,
            });
        });
    }
    createOrder(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { sell, buy, nonce, expirationTimestamp } = input;
            const sellVaultId = sell.vaultId;
            const buyVaultId = buy.vaultId;
            const sellAssetId = starkware_crypto_1.getAssetId(sell);
            const buyAssetId = starkware_crypto_1.getAssetId(buy);
            const sellQuantizedAmount = starkware_crypto_1.quantizeAmount(sell.amount, sell.data.quantum);
            const buyQuantizedAmount = starkware_crypto_1.quantizeAmount(buy.amount, buy.data.quantum);
            const msgHash = yield this._controller.createOrder({
                sellVaultId,
                buyVaultId,
                sellQuantizedAmount,
                buyQuantizedAmount,
                sellAssetId,
                buyAssetId,
                nonce,
                expirationTimestamp,
            });
            const starkSignature = yield this._starkWallet.sign(msgHash);
            return starkSignature;
        });
    }
    configurationHash(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.configurationHash(input);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.configurationHash, result);
        });
    }
    globalConfigurationHash(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.globalConfigurationHash();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.globalConfigurationHash, result);
        });
    }
    depositCancelDelay(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.depositCancelDelay();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.depositCancelDelay, result);
        });
    }
    freezeGracePeriod(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.freezeGracePeriod();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.freezeGracePeriod, result);
        });
    }
    mainGovernanceInfoTag(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainGovernanceInfoTag();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.mainGovernanceInfoTag, result);
        });
    }
    maxVerifierCount(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.maxVerifierCount();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.maxVerifierCount, result);
        });
    }
    unfreezeDelay(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.unfreezeDelay();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.unfreezeDelay, result);
        });
    }
    verifierRemovalDelay(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.verifierRemovalDelay();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.verifierRemovalDelay, result);
        });
    }
    announceAvailabilityVerifierRemovalIntent(verifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.announceAvailabilityVerifierRemovalIntent(verifier);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.announceVerifierRemovalIntent, result);
        });
    }
    announceVerifierRemovalIntent(verifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.announceVerifierRemovalIntent(verifier);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    getRegisteredAvailabilityVerifiers(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getRegisteredAvailabilityVerifiers();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getRegisteredAvailabilityVerifiers, result);
        });
    }
    getRegisteredVerifiers(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getRegisteredVerifiers();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getRegisteredVerifiers, result);
        });
    }
    isAvailabilityVerifier(verifierAddress, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isAvailabilityVerifier(verifierAddress);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isAvailabilityVerifier, result);
        });
    }
    isFrozen(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isFrozen();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isFrozen, result);
        });
    }
    isVerifier(verifierAddress, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isVerifier(verifierAddress);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isVerifier, result);
        });
    }
    mainAcceptGovernance(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainAcceptGovernance();
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    mainCancelNomination(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainCancelNomination();
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    mainIsGovernor(testGovernor, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainIsGovernor(testGovernor);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.mainIsGovernor, result);
        });
    }
    mainNominateNewGovernor(newGovernor, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainNominateNewGovernor(newGovernor);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.mainNominateNewGovernor, result);
        });
    }
    mainRemoveGovernor(governorForRemoval, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.mainRemoveGovernor(governorForRemoval);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    registerAvailabilityVerifier(verifier, identifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerAvailabilityVerifier(verifier, identifier);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    registerVerifier(verifier, identifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerVerifier(verifier, identifier);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    removeAvailabilityVerifier(verifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.removeAvailabilityVerifier(verifier);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    removeVerifier(verifier, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.removeVerifier(verifier);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    unFreeze(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.unFreeze();
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    getAssetInfo(assetType, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getAssetInfo(assetType);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getAssetInfo, result);
        });
    }
    getCancellationRequest(starkKey, assetId, vaultId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getCancellationRequest(starkKey, assetId, vaultId);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getCancellationRequest, result);
        });
    }
    getDepositBalance(starkKey, assetId, vaultId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getDepositBalance(starkKey, assetId, vaultId);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getDepositBalance, result);
        });
    }
    getEthKey(starkKey, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getEthKey(starkKey);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getEthKey, result);
        });
    }
    getFullWithdrawalRequest(starkKey, vaultId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getFullWithdrawalRequest(starkKey, vaultId);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getFullWithdrawalRequest, result);
        });
    }
    getQuantizedDepositBalance(starkKey, assetId, vaultId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getQuantizedDepositBalance(starkKey, assetId, vaultId);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getQuantizedDepositBalance, result);
        });
    }
    getQuantum(presumedAssetType, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getQuantum(presumedAssetType);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getQuantum, result);
        });
    }
    getSystemAssetType(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getSystemAssetType();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getSystemAssetType, result);
        });
    }
    getWithdrawalBalance(starkKey, assetId, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getWithdrawalBalance(starkKey, assetId);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getWithdrawalBalance, result);
        });
    }
    isTokenAdmin(testedAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isTokenAdmin(testedAdmin);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isTokenAdmin, result);
        });
    }
    isUserAdmin(testedAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isUserAdmin(testedAdmin);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isUserAdmin, result);
        });
    }
    registerSystemAssetType(assetType, assetInfo, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerSystemAssetType(assetType, assetInfo);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    registerToken(a, b, c, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerToken(a, b);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    registerTokenAdmin(newAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerTokenAdmin(newAdmin);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    registerUserAdmin(newAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerUserAdmin(newAdmin);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    unregisterTokenAdmin(oldAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.unregisterTokenAdmin(oldAdmin);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    unregisterUserAdmin(oldAdmin, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.unregisterUserAdmin(oldAdmin);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    getLastBatchId(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getLastBatchId();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getLastBatchId, result);
        });
    }
    getOrderRoot(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getOrderRoot();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getOrderRoot, result);
        });
    }
    getOrderTreeHeight(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getOrderTreeHeight();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getOrderTreeHeight, result);
        });
    }
    getSequenceNumber(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getSequenceNumber();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getSequenceNumber, result);
        });
    }
    getVaultRoot(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getVaultRoot();
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getVaultRoot, result);
        });
    }
    getVaultTreeHeight(txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getVaultTreeHeight();
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    isOperator(testedOperator, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.isOperator(testedOperator);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.isOperator, result);
        });
    }
    registerOperator(newOperator, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.registerOperator(newOperator);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    setAssetConfiguration(assetId, configHash, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.setAssetConfiguration(assetId, configHash);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    setGlobalConfiguration(configHash, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.setGlobalConfiguration(configHash);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    unregisterOperator(removedOperator, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.unregisterOperator(removedOperator);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    updateState(publicInput, applicationData, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.updateState(publicInput, applicationData);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    forcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce, signature, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.forcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce, signature);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    forcedWithdrawalRequest(starkKey, vaultId, quantizedAmount, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.forcedWithdrawalRequest(starkKey, vaultId, quantizedAmount);
            const txhash = yield this._sendContractTransaction(data, txOpts);
            return txhash;
        });
    }
    getForcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getForcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getForcedTradeRequest, result);
        });
    }
    getForcedWithdrawalRequest(starkKey, vaultId, quantizedAmount, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield this._controller.getForcedWithdrawalRequest(starkKey, vaultId, quantizedAmount);
            const result = yield this._callContract(data, txOpts);
            return this._controller.parseReturnData(this._controller.getForcedWithdrawalRequest, result);
        });
    }
    perpetualTransfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { asset, fee, sender, receiver, nonce, expirationTimestamp, condition, } = params;
            const assetId = starkware_crypto_1.getAssetId(asset);
            const assetIdFee = starkware_crypto_1.getAssetId(fee);
            const amount = asset.amount;
            const receiverPublicKey = receiver.starkKey;
            const senderPositionId = sender.positionId;
            const receiverPositionId = receiver.positionId;
            const feePositionId = fee.positionId;
            const maxAmountFee = fee.maxAmount;
            const msgHash = yield this._controller.perpetualTransfer({
                assetId,
                assetIdFee,
                receiverPublicKey,
                senderPositionId,
                receiverPositionId,
                feePositionId,
                nonce,
                amount,
                maxAmountFee,
                expirationTimestamp,
                condition,
            });
            const starkSignature = yield this._starkWallet.sign(msgHash);
            return starkSignature;
        });
    }
    perpetualLimitOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { syntheticAsset, collateralAsset, isBuyingSynthetic, fee, nonce, positionId, expirationTimestamp, } = params;
            const assetIdSynthetic = starkware_crypto_1.getAssetId(syntheticAsset);
            const assetIdCollateral = starkware_crypto_1.getAssetId(collateralAsset);
            const assetIdFee = starkware_crypto_1.getAssetId(fee);
            const amountSynthetic = syntheticAsset.amount;
            const amountCollateral = collateralAsset.amount;
            const amountFee = fee.amount;
            const msgHash = yield this._controller.perpetualLimitOrder({
                assetIdSynthetic,
                assetIdCollateral,
                isBuyingSynthetic,
                assetIdFee,
                amountSynthetic,
                amountCollateral,
                amountFee,
                nonce,
                positionId,
                expirationTimestamp,
            });
            const starkSignature = yield this._starkWallet.sign(msgHash);
            return starkSignature;
        });
    }
    perpetualWithdrawal(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { collateralAsset, positionId, nonce, expirationTimestamp } = params;
            const assetIdCollateral = starkware_crypto_1.getAssetId(collateralAsset);
            const amount = collateralAsset.amount;
            const msgHash = yield this._controller.perpetualWithdrawal({
                assetIdCollateral,
                positionId,
                nonce,
                expirationTimestamp,
                amount,
            });
            const starkSignature = yield this._starkWallet.sign(msgHash);
            return starkSignature;
        });
    }
    starkSignMessage(message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkWallet.sign(message);
        });
    }
    signMessage(message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('signMessage', message);
            return this._signerWallet.signMessage(message);
        });
    }
    starkSignTransaction(tx) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkWallet.signTransaction(tx);
        });
    }
    signTransaction(tx) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._signerWallet.signTransaction(tx);
        });
    }
    starkSendTransaction(tx) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkWallet.sendTransaction(tx);
        });
    }
    sendTransaction(unsignedTx) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('sendTransaction', unsignedTx);
            if (unsignedTx.value) {
                if (!enc_utils_1.isHexString(unsignedTx.value)) {
                    unsignedTx.value = enc_utils_1.sanitizeHex(enc_utils_1.numberToHex(unsignedTx.value));
                }
            }
            if (unsignedTx.gas) {
                unsignedTx.gasLimit = unsignedTx.gas;
                delete unsignedTx.gas;
            }
            if (unsignedTx.from) {
                unsignedTx.from = ethers.utils.getAddress(unsignedTx.from);
            }
            const populatedTx = yield this._signerWallet.populateTransaction(unsignedTx);
            this._debugLog('sendTransaction signerAddress', yield this._signerWallet.getAddress());
            return this._signerWallet.sendTransaction(populatedTx);
        });
    }
    _callContract(data, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('_callContract', data, txOpts);
            const unsignedTx = Object.assign(Object.assign({ to: this.contractAddress, data }, txOpts), { gasLimit: '0x7a120' });
            const populatedTx = yield this._signerWallet.populateTransaction(unsignedTx);
            return this._signerWallet.provider.call(populatedTx);
        });
    }
    _sendContractTransaction(data, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._debugLog('_sendContractTransaction', data, txOpts);
            const unsignedTx = Object.assign({ to: this.contractAddress, data }, txOpts);
            const tx = yield this.sendTransaction(unsignedTx);
            return tx.hash;
        });
    }
}
exports.default = StarkwareProvider;
//# sourceMappingURL=provider.js.map